import { render, staticRenderFns } from "./CssVariables.vue?vue&type=template&id=0e4967d8"
import script from "./CssVariables.vue?vue&type=script&lang=ts"
export * from "./CssVariables.vue?vue&type=script&lang=ts"
import style0 from "./CssVariables.vue?vue&type=style&index=0&id=0e4967d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports